window.jax = {};
var nundefined,
    emptyArray = [],
    slice = emptyArray.slice;
jax.isFunction = function (obj) {
    return typeof obj === "function";
};

jax.isObject = function (obj) {
    var type = typeof obj;
    return type === "function" || type === "object" && !!obj;
};
jax.param = function (obj, prefix) {
    var str = [];

    for (var p in obj) {

        if (jax.isFunction(obj[p])) {
            continue;
        }
        var k = prefix ? prefix + "[" + p + "]" : p,
            v = obj[p];
        str.push(jax.isObject(v) ? abjax.param(v, k) : (k) + "=" + encodeURIComponent(v));
    }

    return str.join("&");
};

jax.extend = function (target) {
    if (target == nundefined)
        target = this;
    if (arguments.length === 1) {
        for (var key in target)
            this[key] = target[key];
        return this;
    } else {
        slice.call(arguments, 1).forEach(function (source) {
            for (var key in source)
                target[key] = source[key];
        });
    }
    return target;
};


function empty() {}
jax.ajaxSettings = {
    type: "GET",
    beforeSend: empty,
    success: empty,
    error: empty,
    complete: empty,
    context: undefined,
    timeout: 0,
    crossDomain: null,
    processData: true
};



jax.ajax = function (opts) {
    var xhr;
    var url;
    if (typeof (opts) === "string") {
        var oldUrl = opts;
        opts = {
            url: oldUrl
        };
    }
    var settings = opts || {};
    for (var key in jax.ajaxSettings) {
        if (typeof (settings[key]) === "undefined")
            settings[key] = jax.ajaxSettings[key];
    }
    ////////////////////////////////////////////////////////////////////////////////try {
    if (!settings.url)
        settings.url = window.location;

    if (!settings.headers)
        settings.headers = {};

    if (!("async" in settings) || settings.async !== false)
        settings.async = true;

    if (settings.processData && jax.isObject(settings.data))
        settings.data = jax.param(settings.data);
    if (settings.type.toLowerCase() === "get" && settings.data) {
        if (settings.url.indexOf("?") === -1)
            settings.url += "?" + settings.data;
        else
            settings.url += "&" + settings.data;
    }
    if (settings.data) {
        if (!settings.contentType && settings.contentType !== false)
            settings.contentType = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    if (!settings.dataType)
        settings.dataType = "text/html";
    else {
        switch (settings.dataType) {
        case "script":
            settings.dataType = "text/javascript, application/javascript";
            break;
        case "json":
            settings.dataType = "application/json";
            break;
        case "xml":
            settings.dataType = "application/xml, text/xml";
            break;
        case "html":
            settings.dataType = "text/html";
            break;
        case "text":
            settings.dataType = "text/plain";
            break;
        case "jsonp":
            return $.jsonP(opts);
        default:
            settings.dataType = "text/html";
            break;
        }
    }

    if (settings.crossDomain === null) settings.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(settings.url) &&
        RegExp.$2 !== window.location.host;

    if (!settings.crossDomain)
        settings.headers = jax.extend({
            "X-Requested-With": "XMLHttpRequest"
        }, settings.headers);
    var abortTimeout;
    var context = settings.context;
    var protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol;

    //ok, we are really using xhr
    xhr = new window.XMLHttpRequest();

    xhr.onreadystatechange = function () {
        var mime = settings.dataType;
        if (xhr.readyState === 4) {
            clearTimeout(abortTimeout);
            var result, error = false;
            var contentType = xhr.getResponseHeader("content-type") || "";
            if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0 && protocol === "file:") {
                if ((contentType === "application/json") || (mime === "application/json" && !(/^\s*$/.test(xhr.responseText)))) {
                    try {
                        result = JSON.parse(xhr.responseText);
                    } catch (e) {
                        error = e;
                    }
                } else if (contentType.indexOf("javascript") !== -1) {
                    try {
                        result = xhr.responseText;
                        window["eval"](result);
                    } catch (e) {
                        console.log(e);
                    }
                } else if (mime === "application/xml, text/xml") {
                    result = xhr.responseXML;
                } else if (mime === "text/html") {
                    result = xhr.responseText;
                    console.log("=============== Really? You are receiving HTML??? ================")
                } else
                    result = xhr.responseText;
                //If we're looking at a local file, we assume that no response sent back means there was an error
                if (xhr.status === 0 && result.length === 0)
                    error = true;
                if (error) {
                    settings.error.call(context, xhr, "parsererror", error);
                } else {

                    settings.success.call(context, result, "success", xhr);
                }
            } else {
                error = true;

                settings.error.call(context, xhr, "error");
            }
            var respText = error ? "error" : "success";
            settings.complete.call(context, xhr, respText);
        }
    };
    xhr.open(settings.type, settings.url, settings.async);
    if (settings.withCredentials) xhr.withCredentials = true;

    if (settings.contentType)
        settings.headers["Content-Type"] = settings.contentType;
    for (var name in settings.headers)
        if (typeof settings.headers[name] === "string")
            xhr.setRequestHeader(name, settings.headers[name]);
    if (settings.beforeSend.call(context, xhr, settings) === false) {
        xhr.abort();
        return false;
    }

    if (settings.timeout > 0)
        abortTimeout = setTimeout(function () {
            xhr.onreadystatechange = empty;
            xhr.abort();
            settings.error.call(context, xhr, "timeout");
        }, settings.timeout);
    xhr.send(settings.data);
    ////////////////////////////////////////////////////////////////////////////////} catch (e) {
    // General errors (e.g. access denied) should also be sent to the error callback

    ////////////////////////////////////////////////////////////////////////////////    settings.error.call(context, xhr, "error", e);
    ////////////////////////////////////////////////////////////////////////////////}
    return xhr;
};
